var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.517,
    height: 17.533,
    viewBox: "0 0 17.517 17.533",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_114",
    "data-name": "Rectangle 114",
    width: 17.517,
    height: 17.533,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_109",
    "data-name": "Group 109",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_108",
    "data-name": "Group 108",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3710",
    "data-name": "Path 3710",
    d: "M16.249,9.185V8.226a.948.948,0,0,0-.009-.157V8.052A7.524,7.524,0,1,0,2.725,13.245v.035l-.192.819-.061.262-.359,1.613,1.581-.5.523-.166.568-.174A7.526,7.526,0,0,0,16.241,9.185ZM14.678,2.3A8.751,8.751,0,0,1,4.436,16.356l-.689.218L.7,17.533l.69-3.111.157-.705A8.755,8.755,0,0,1,14.678,2.3",
    transform: "translate(0 0)",
    fill: "#e4001b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3711",
    "data-name": "Path 3711",
    d: "M4.726,4.776a2.2,2.2,0,0,0-.48,1.673c-.237,2.536,3.606,6.518,6.12,6.283a2.09,2.09,0,0,0,2.007-.9.984.984,0,0,0,.106-.88c-.21-.41-1.564-.854-2.009-1.037-.262-.1-.856.288-1.013.5s-.445.061-.445.061A9.671,9.671,0,0,1,6.428,7.634s-.122-.3.106-.435.68-.689.593-.958-.734-2-.734-2S6.175,3.87,5.4,4.158a2.418,2.418,0,0,0-.664.618Z",
    transform: "translate(0.383 0.366)",
    fill: "#e4001b",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsapp-icon.af24bd99ecd9b70e0e9c029cb1705992.svg";
export { ForwardRef as ReactComponent };